import React from 'react';

import {FontVariant, Text} from '@pexip/components';

import {SpeakingIndicator} from '../SpeakingIndicator/SpeakingIndicator.view';

import styles from './SpeakerPill.module.scss';

export const SpeakerPill: React.FC<{speakerName: string}> = ({speakerName}) => (
    <div className={styles.speakerPill}>
        <Text fontVariant={FontVariant.XSmall} className={styles.speakerName}>
            {speakerName}
        </Text>
        <SpeakingIndicator className={styles.indicator} />
    </div>
);
